import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation NotificationRemove($ids: [ID]!) {
    notificationRemove(ids: $ids)
  }
`

export default function useRemoveNotification() {
  const { onMutate: onRemoveNotification, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'notificationRemove',
    successMessage: ''
  })
  return { onRemoveNotification, loading }
}
